import React from 'react';
// eslint-disable-next-line import/no-named-default
import classNames from 'classnames';
import { default as ReactLoader } from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

const SIZE_SMALL = 'small';
const SIZE_MEDIUM = 'medium';
const SIZE_LARGE = 'large';

const Loader = ({
  className,
  type = 'Circles',
  size = SIZE_LARGE,
  overlay = false,
}) => {
  let height;
  let width;
  let sizeToApply = size;

  if (sizeToApply === SIZE_LARGE) {
    height = 80;
    width = 80;
  }
  if (sizeToApply === SIZE_MEDIUM) {
    height = 50;
    width = 50;
  }
  if (sizeToApply === SIZE_SMALL) {
    height = 20;
    width = 20;
  }

  return (
    <div
      className={classNames('loader', overlay && 'with-overlay', className)}
    >
      <ReactLoader type={type} height={height} width={width} />
    </div>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js